import styled from 'styled-components';

export const Container = styled.div`
    margin: 0 auto 1rem;
    max-width: 500px;
    h1{
      margin-bottom: 24px;
    }
`;

export const Form = styled.form`
    border-radius: 6px;
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 30%);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 24px 16px;
    min-height: 214px;

    button{
      margin-top: 24px;
    }

    select{
      margin-top: 16px;
    }
`;
